<template>
	<div>
		<div class="page-title">
			<icon-font class="title-icon" type="icon-hunhemeiti" style="margin-right: 12px"/>
			<span>Meta+AF-TRIP</span>
		</div>
		<a-tabs v-model="activeKey" type="card" class="page-tabs">
			<a-tab-pane key="data" tab="Meta+AF-TRIP数据"></a-tab-pane>
			<a-tab-pane key="export" tab="离线数据导入"></a-tab-pane>
		</a-tabs>
		<div v-if="activeKey === 'data'">
			<MediaData code="META-AF-TRIP"></MediaData>
		</div>
		<div v-if="activeKey === 'export'">
			<MediaDataExport code="META-AF-TRIP"></MediaDataExport>
		</div>
	</div>
</template>
<script>
import MediaData from "./components/mediaData.vue"
import MediaDataExport from "./components/mediaDataExport.vue"

export default {
	name: 'metaAndAfTrip',
	data() {
		return {
			activeKey: 'data',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10
			},
			data: [],
		}
	},
	methods: {
		openEC() {
			window.open('http://adpub.yeahtargeter.com/', '_blank')
		},
	},
	components: {
		MediaData,
		MediaDataExport
	}
}
</script>
<style lang="less" scoped>
	.page-tabs {
		margin-top: 24px;
		padding-left: 24px;
		/deep/ .ant-tabs-bar {
			border-bottom: none;
		}
	}
</style>